// src/data/logoimages.js
// import shrileelalogo from '../assets/logos/shrileela-remove bgceop.png';
// import Mirangelogo from '../../assets/logos/webp/Miranshwhitecrop.webp'
// import dreamlandLogo from "../assets/logos/webp/dreamland.webp";
// import miranshLogo from "../assets/logos/webp/miransh.webp";
// import shreelilaLogo from "../assets/logos/webp/shrileela.webp";
// import dreamlandHorizontal from "../assets/logos/webp/dreamland hori.webp";





const shrileelalogo ='https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_800/v1778297944/shrileela-remove_bgceop_g8ffe2.png'
const Mirangelogo =
"https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_800/v1778353334/Miranshwhitecrop_lzge2i.png";


const dreamlandLogo =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_800/v1778436907/dreamland_icityt.webp";

const miranshLogo =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_800/v1778436907/miransh_ptjm0i.webp";

const shreelilaLogo =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_800/v1778436908/shrileela_kekchb.webp";

const dreamlandHorizontal =
  "https://res.cloudinary.com/dzkkaxjj8/image/upload/f_auto,q_auto,w_1200/v1778436908/dreamland_hori_fjhve2.webp";


export const logoimages = {
  logos: {
    shrileela: shrileelalogo,
    Miransh :Mirangelogo,
    landingpage: {
  dreamlandLogo,
  miranshLogo,
  shreelilaLogo,
  dreamlandHorizontal,
}
  }
}